import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/billing/subscription';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* process() {
  try {
    const response = yield call(
      axios.get,
      `${config.API_URL}/billing/subscription`,
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(response.data?.data ?? response.data));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, process);
}
